import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from 'src/app/core/objects/user';
import { UserService } from 'src/app/core/services/user.service';
import { WhiteLabelService } from 'src/app/core/services/white-label.service';
import { CompanyBranding } from 'src/app/core/types';

@Component({
    selector: 'gl-pro-modal',
    templateUrl: './pro-modal.component.html',
    styleUrls: ['./pro-modal.component.scss'],
    standalone: false
})
export class ProModalComponent {
  @Input() public disableCloseButton = false;
  public user: User;
  public logo: CompanyBranding;
  @Output() private closeModal = new EventEmitter<any>();

  constructor(private userService: UserService, private whiteLabelService: WhiteLabelService) {
    this.user = this.userService.getState();
    this.logo = this.whiteLabelService.getState();
  }

  public close(): void {
    this.closeModal.emit();
  }
}
